<template>
  <div class="legal-consulting-services">
    <img src="https://tokencloud-test.oss-cn-beijing.aliyuncs.com/static/tc-anti-fraud/20260604-134517.jpg" alt="services" />
  </div>
</template>

<script>
export default {
  name: 'LegalConsultingServices',
};
</script>

<style scoped>
.legal-consulting-services {
  display: flex;
  justify-content: center;
  align-items: center;
}
.legal-consulting-services img {
  max-width: 100%;
  height: auto;
  display: block;
}
</style>
